/*
 * One-time purchase as a link under the add-to-cart button.
 *
 * Subscription is the default; the purchase-type radios are still in the
 * page, hidden, because lp-pdp.js and the Sanavae Bundles embed read the
 * purchase type from them. This keeps the link's price on the selected
 * bundle, mirrors the cadence line, and on click buys the bundle once through
 * the same form — so gifts and skip-cart behave exactly as for a subscription.
 */
(function () {
  function wire(box) {
    var link = box.querySelector("[data-lp-onetime]");
    if (!link || link.dataset.wired) return;
    link.dataset.wired = "1";

    var priceEl = link.querySelector("[data-lp-onetime-price]");
    var once = box.querySelector('[data-lp-purchase="once"] input');
    var subscribe = box.querySelector('[data-lp-purchase="subscribe"] input');
    var form = box.querySelector('form[action*="/cart/add"]');

    function selectedPaid() {
      var input = box.querySelector("[data-lp-bundle-input]:checked");
      var card = input && input.closest("[data-lp-bundle]");
      if (!card) return 1;
      return Math.min(Number(card.dataset.paid), Number(card.dataset.qty)) || 1;
    }

    function update() {
      if (!priceEl || typeof box.currentVariant !== "function") return;
      var variant = box.currentVariant();
      if (variant) priceEl.textContent = box.format(Math.round(variant.price * selectedPaid()));
    }

    function choose(input) {
      if (!input || input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    box.addEventListener("change", function () {
      // After lp-pdp.js and the embed have updated data-paid.
      setTimeout(update, 0);
    });
    update();
    // The bundles embed rewrites data-paid after this runs; follow it.
    box.querySelectorAll("[data-lp-bundle]").forEach(function (card) {
      new MutationObserver(update).observe(card, { attributes: true, attributeFilter: ["data-paid"] });
    });

    // The cadence line lives in the hidden subscribe option, where the
    // bundles embed keeps it current; show a copy under the button.
    var source = box.querySelector('[data-lp-purchase="subscribe"] small');
    var mirror = box.querySelector("[data-lp-cadence-mirror]");
    if (source && mirror) {
      // "Delivery every 4 weeks. Cancel anytime!" → "Refills Ship Every 4 Weeks".
      var copy = function () {
        var m = source.textContent.match(/(\d+)\s*(day|week)/i);
        if (!m) return;
        var n = Number(m[1]);
        var weeks = /day/i.test(m[2]) && n % 7 === 0 ? n / 7 : /week/i.test(m[2]) ? n : null;
        mirror.textContent =
          weeks === 1 ? "Refills Ship Every Week"
          : weeks ? "Refills Ship Every " + weeks + " Weeks"
          : "Refills Ship Every " + n + " Days";
      };
      copy();
      new MutationObserver(copy).observe(source, { childList: true, characterData: true, subtree: true });
    }

    link.addEventListener("click", function () {
      if (!form || !once) return;
      choose(once);
      if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      // Back to the default, for whoever comes back to the page.
      setTimeout(function () { choose(subscribe); }, 1500);
    });
  }

  function start() {
    document.querySelectorAll("lp-buy-box").forEach(wire);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
